export default "__VITE_ASSET__DYn9A6Yu__"